import { getPolygonPath, hasValidPolygon, toPointGeometry } from '../../containers/sites/siteSteps/locationGeometry';

export const ATTRIBUTION_WINDOWS = [7, 14, 30].map(days => ({ id: days, label: `${days} days` }));

export const retailSiteType = types => types.find(type => [type.stdName, type.displayName]
  .some(name => String(name || '').toLowerCase() === 'retail')) ||
  types.find(type => [type.stdName, type.displayName]
    .some(name => String(name || '').toLowerCase().replace(/[\s-]+/g, '_') === 'retail_store'));

export const newTargetSite = type => ({
  displayName: '',
  description: '',
  type: type || null,
  latitude: '',
  longitude: '',
  address: '',
  countryCode: '',
  campaignId: '',
  attributionWindowDays: 7
});

export const validSettings = site => Boolean(site.displayName.trim().length >= 4 && site.type?.id);
const coordinateIsValid = (value, limit) => value !== '' && value !== null && value !== undefined &&
  Number.isFinite(Number(value)) && Math.abs(Number(value)) <= limit;

export const validLocation = site => {
  if (!coordinateIsValid(site.latitude, 90) || !coordinateIsValid(site.longitude, 180)) return false;
  if (site.geometry?.type?.toLowerCase() === 'polygon') {
    return hasValidPolygon(site.geometry) && getPolygonPath(site.geometry)
      .every(point => coordinateIsValid(point.lat, 90) && coordinateIsValid(point.lng, 180));
  }
  return Number(site.type?.radius) > 0;
};

export const validAttribution = (site, campaigns) => campaigns.some(campaign => campaign.value === site.campaignId) &&
  ATTRIBUTION_WINDOWS.some(window => window.id === site.attributionWindowDays);

// Creation uses the selected portal and its company.
export const targetSiteRequest = (site, portalId, companyId) => ({
  parent: `brandportals/${portalId}`,
  campaignId: site.campaignId,
  attributionWindowDays: site.attributionWindowDays,
  site: {
    companyId,
    displayName: site.displayName.trim(),
    description: site.description.trim(),
    type: { ...site.type },
    address: site.address,
    countryCode: site.countryCode,
    latitude: Number(site.latitude),
    longitude: Number(site.longitude),
    geometry: site.geometry?.type?.toLowerCase() === 'polygon'
      ? site.geometry
      : toPointGeometry({ lat: Number(site.latitude), lng: Number(site.longitude) }),
    solution: 'CUSTOM',
    datasources: ['MOBILE_M'],
    status: 'ENABLED'
  }
});
